var closeMobileMenu;

prepMobileMenu = () => {
  
  const hammyTrigger = document.querySelector('.hammy');
  const hammyLines = hammyTrigger.querySelectorAll("span");
  const close = document.querySelector('nav .close');
  const closeLinesWrapper = close.querySelectorAll('div');
  const closeLines = close.querySelectorAll('span');
  const mobileMenu = document.getElementById('mobile-menu');
  const closeTrigger = mobileMenu.querySelector('.close');
  let pageScrollLock = null;

  const lockPageScroll = () => {
    if (pageScrollLock) return;

    const bodyStyle = document.body.style;
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;

    pageScrollLock = {
      scrollY: scrollY,
      position: bodyStyle.position,
      top: bodyStyle.top,
      left: bodyStyle.left,
      right: bodyStyle.right,
      width: bodyStyle.width,
      overflow: bodyStyle.overflow
    };

    document.documentElement.classList.add('cp-mobile-menu-open');
    document.body.classList.add('cp-mobile-menu-open');
    bodyStyle.position = 'fixed';
    bodyStyle.top = `-${scrollY}px`;
    bodyStyle.left = '0';
    bodyStyle.right = '0';
    bodyStyle.width = '100%';
    bodyStyle.overflow = 'hidden';
  };

  const unlockPageScroll = () => {
    if (!pageScrollLock) return;

    const bodyStyle = document.body.style;
    const scrollY = pageScrollLock.scrollY;

    bodyStyle.position = pageScrollLock.position;
    bodyStyle.top = pageScrollLock.top;
    bodyStyle.left = pageScrollLock.left;
    bodyStyle.right = pageScrollLock.right;
    bodyStyle.width = pageScrollLock.width;
    bodyStyle.overflow = pageScrollLock.overflow;

    document.documentElement.classList.remove('cp-mobile-menu-open');
    document.body.classList.remove('cp-mobile-menu-open');
    pageScrollLock = null;
    window.scrollTo(0, scrollY);
  };

  const updateMobileMenuOffset = () => {
    const header = document.querySelector('#shopify-section-header #header');
    const announcement = document.querySelector('#shopify-section-announcement-bar .announcement-bar');

    let offset = 85;
    let headerHeight = 0;

    if (header) {
      const headerRect = header.getBoundingClientRect();
      headerHeight = headerRect.height;
      offset = headerRect.bottom;
    }

    if (announcement) {
      const announcementRect = announcement.getBoundingClientRect();
      const announcementVisible = announcementRect.height > 0 && window.getComputedStyle(announcement).display !== 'none';

      if (announcementVisible) {
        offset = Math.max(offset, announcementRect.bottom + headerHeight);
      }
    }

    offset = Math.max(0, Math.ceil(offset));
    document.documentElement.style.setProperty('--cp-mobile-menu-top-offset', `${offset}px`);
    document.documentElement.style.setProperty('--cp-mobile-menu-viewport-height', `${window.innerHeight}px`);
  };

  gsap.set(closeLinesWrapper[0], { xPercent: -50, yPercent: -50, rotate: 45 })
  gsap.set(closeLinesWrapper[1], { xPercent: -50, yPercent: -50, rotate: -45 })

  let mobileMenuOpen = false;

  let openMobileMenu = () => {
    
    if (mobileMenuOpen) { return; }
    updateMobileMenuOffset();
    gsap.to(mobileMenu, 0.35, { autoAlpha: 1, pointerEvents: 'all', ease: Expo.easeOut, force3D: true });
    gsap.to(mobileMenu, 0.85, { x: 0, ease: Expo.easeOut, force3D: true });
    gsap.to(hammyLines, 0.35, { scaleX: 0, transformOrigin: "100% 50%", ease: Sine.easeOut, stagger: 0.12, force3D: true });
    gsap.to(closeLines[0], 0.35, { scaleX: 1, transformOrigin: "0% 50%", ease: Sine.easeOut, delay: 0.25, force3D: true });
    gsap.to(closeLines[1], 0.35, { scaleX: 1, transformOrigin: "0% 50%", ease: Sine.easeOut, delay: 0.35, force3D: true });
    mobileMenuOpen = true;
    lockPageScroll();
  };

  closeMobileMenu = () => {
    if (!mobileMenuOpen) { return; }
    let openDrawer = mobileMenu.querySelector('.drawer.open');
    if (openDrawer) {
      gsap.delayedCall(0.3, () => {
        openDrawer.click();
      });

    }
    gsap.to(mobileMenu, 0.55, { autoAlpha: 0, pointerEvents: 'none', ease: Expo.easeOut, force3D: true });
    gsap.to(mobileMenu, 0.85, { x: -70, ease: Expo.easeOut, force3D: true });
    gsap.to(hammyLines, 0.25, { scaleX: 1, transformOrigin: "100% 50%", ease: Sine.easeOut, stagger: 0.06, delay: 0.1, force3D: true });
    gsap.to(closeLines[0], 0.25, { scaleX: 0, transformOrigin: "0% 50%", ease: Sine.easeOut, force3D: true });
    gsap.to(closeLines[1], 0.25, { scaleX: 0, transformOrigin: "0% 50%", ease: Sine.easeOut, force3D: true });
    mobileMenuOpen = false;
    unlockPageScroll();
  };

  hammyTrigger.addEventListener('click', () => {
    
    if (mobileMenuOpen) {
      closeMobileMenu();
    } else {
      openMobileMenu();
    }
  });

  closeTrigger.addEventListener('click', () => {
    closeMobileMenu();
  });

  updateMobileMenuOffset();
  window.addEventListener('load', updateMobileMenuOffset);
  window.addEventListener('resize', updateMobileMenuOffset);
  window.addEventListener('orientationchange', updateMobileMenuOffset);
};
